import { Button } from 'antd';
import React, { FC } from 'react';

import styles from './ChatMessage.module.scss';

type Props = {
  messageData: {
    date: string | JSX.Element;
    message: string;
    fileData?: string;
    fileName?: string;
    read: boolean;
    client?: boolean;
    status?: boolean;
  };
};

const downloadFile = (fileData: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = fileData;
  link.download = fileName;
  link.click();
};

export const ChatMessage: FC<Props> = ({ messageData }) => {
  return (
    <div
      className={`${styles.message} ${
        !messageData.read && !messageData.client
          ? styles['message--unread']
          : messageData.client
            ? styles['message--client']
            : ''
      }`}
    >
      <div className={styles['message__header']}>
        <div className={styles['message__header__top']}>
          {messageData.status && (
            <div className={styles['message__header__top__tag']}>
              {/* <span>!</span> */}
            </div>
          )}

          <div className={styles['message__header__top__date']}>
            {messageData.date}
          </div>
        </div>

        {!messageData.read && !messageData.client ? (
          <div className={styles['message__header__read']}>
            Новое сообщение!
          </div>
        ) : messageData.client && !messageData.read ? (
          <div className={styles['message__header__read']}>Не прочитано</div>
        ) : null}
      </div>

      <p>{messageData.message}</p>

      {messageData.fileData && messageData.fileName && (
        <div className={styles['message__file']}>
          <Button
            className={styles['message__file__button']}
            size="small"
            type="link"
            onClick={() =>
              downloadFile(messageData.fileData!, messageData.fileName!)
            }
          >
            {messageData.fileName}
          </Button>
        </div>
      )}
    </div>
  );
};
